import { render } from "./jupyterhub.vue?vue&type=template&id=252018c8&scoped=true"
import script from "./jupyterhub.vue?vue&type=script&lang=js"
export * from "./jupyterhub.vue?vue&type=script&lang=js"

import "./jupyterhub.vue?vue&type=style&index=0&id=252018c8&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252018c8"]])

export default __exports__